module.exports = __webpack_public_path__ + "static/img/login.6cb40aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login.png
// module id = 6QGk
// module chunks = 1